import { User, Hospital, TrendUp, Handshake } from "@phosphor-icons/react";
import { Reveal } from "../components/Reveal";
import InquiryForm from "../components/InquiryForm";

const AUDIENCES = [
    { icon: User, title: "For Patients", text: "I am exploring healthcare options", interest: "Exploring healthcare options (Patient)", testid: "contact-audience-patients" },
    { icon: Hospital, title: "For Hospitals", text: "I want to become a partner", interest: "Hospital Partnership", testid: "contact-audience-hospitals" },
    { icon: TrendUp, title: "For Investors", text: "I want to learn about GoMedVoyage", interest: "Investment", testid: "contact-audience-investors" },
    { icon: Handshake, title: "For Partners", text: "I want to collaborate", interest: "Strategic Partnership", testid: "contact-audience-partners" },
];

export default function ContactBlock({ selectedInterest, onSelect, testidPrefix = "contact" }) {
    return (
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
            <div className="lg:col-span-5">
                <Reveal>
                    <div className="space-y-4">
                        {AUDIENCES.map((a) => {
                            const active = selectedInterest === a.interest;
                            return (
                                <button
                                    key={a.title}
                                    data-testid={a.testid}
                                    onClick={() => onSelect(a.interest)}
                                    className={`w-full flex items-center gap-5 rounded-3xl border p-6 text-left transition-[border-color,box-shadow,transform] duration-300 hover:-translate-y-0.5 ${
                                        active
                                            ? "border-brand-green/40 bg-tint-green shadow-[0_12px_30px_rgb(13,148,136,0.10)]"
                                            : "border-slate-100 bg-white shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:border-brand-green/25"
                                    }`}
                                >
                                    <div className={`w-11 h-11 shrink-0 rounded-2xl flex items-center justify-center transition-colors duration-300 ${active ? "bg-brand-green text-white" : "bg-tint-blue text-brand-blue"}`}>
                                        <a.icon size={22} weight="duotone" />
                                    </div>
                                    <div>
                                        <p className="font-heading text-base font-semibold text-brand-blue">{a.title}</p>
                                        <p className="text-sm text-slate-600">{a.text}</p>
                                    </div>
                                </button>
                            );
                        })}
                    </div>
                </Reveal>
            </div>
            <div className="lg:col-span-7">
                <Reveal delay={0.15}>
                    <div className="rounded-3xl border border-slate-100 bg-white p-8 sm:p-10 shadow-[0_16px_48px_rgb(10,37,64,0.08)]">
                        <InquiryForm key={selectedInterest} defaultInterest={selectedInterest} testidPrefix={testidPrefix} />
                    </div>
                </Reveal>
            </div>
        </div>
    );
}
